import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getForecastHistoryFilterData = createApi(`getForecastHistoryFilterDataSlice`, "GET");

const getForecastHistoryFilterDataSlice = createSlice({
  name: 'getForecastHistoryFilterDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getForecastHistoryFilterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getForecastHistoryFilterData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getForecastHistoryFilterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getForecastHistoryFilterDataSlice.reducer;
